/**
 * 
 * CenterWrapper.js
 * 
 */


import React, { Component } from 'react'
import { Container } from 'react-bootstrap';

 
 export default class CenterWrapper extends Component {

    static displayName = CenterWrapper.name;

     render() {

         return (
             
            <Container id={this.props.id} style={{ backgroundColor: '', paddingLeft: '200px', paddingTop: '200px', paddingBottom: '100px' }} >
                
                {this.props.children}

            </Container>

         )

     }


 }
 

 
